'use strict';

var DemandPostingOperationDirective = function DemandPostingOperationDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-posting-operation.html'),
    controller: 'DemandPostingOperationController',
    scope: {
      operationIdx: '=',
      operation: '=',
      operationType: '=',
      onProductGroupChange: '&',
      onAdjAmountChange: '&',
      onDelete: '&'
    },
    link: function link() {}
  };
};
DemandPostingOperationDirective.$inject = [];
module.exports = DemandPostingOperationDirective;